
const data = [
    { id: 1, link: '#', title: 'Inicio' },
    { id: 2, link: '#sobre_mi', title: 'Sobre Mí' },
    { id: 3, link: '#servicios', title: 'Servicios' },
    { id: 4, link: '#faqs', title: 'Preguntas Frecuentes' },
    { id: 5, link: '#contacto', title: 'Contacto' }
]

export default data;